module.exports = __webpack_public_path__ + "img/green-shield.1653858e.svg";